import { apiSlice } from "../../app/api/apiSlice";

export const getReLockProductSearchSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getReLockProductSearch: builder.mutation({
			query: (body) => ({
				url: "api/v1/loan/get_relock_products_search/",
				method: "POST",
				body: body?.formData,
			}),
		}),
	}),
});

export const { useGetReLockProductSearchMutation } = getReLockProductSearchSlice;
